export default __webpack_public_path__ + "media/react/b2b/app/pages/student/student_report/writing-4076771695972caef8d4bac9c5601f51.svg";